import React from 'react';
import { NewPage } from '../components/WorkArea/NewPage/NewPage';

export const ViewPage = () => {
    return (
        <div>
            <NewPage mode={'viewing'} />
        </div>
    )
}